/**
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>.
 */

'use strict';

module.exports = function ( callback ) {
    var deviceInfo = {
        type: '',
        model: ''
    };

    if ( PLATFORM === 'MAG' ) {
        deviceInfo.type = 'stb';

        try {
            deviceInfo.model = window.top.gSTB.GetDeviceModelExt(); //eslint-disable-line
        } catch ( error ) {
            // no need to handle :)
            console.log(error);
        }

        callback(deviceInfo);
    } else if ( PLATFORM === 'TIZEN' ) { //eslint-disable-line
        deviceInfo.type = 'tizen';

        try {
            deviceInfo.model = window.top.webapis.productinfo.getRealModel();
        } catch ( error ) {
            // no need to handle:)
            console.log(error);
        }

        callback(deviceInfo);
    } else if ( PLATFORM === 'WEBOS' ) { //eslint-disable-line
        deviceInfo.type = 'webos';
        callback(deviceInfo);
    } else if ( PLATFORM === 'SMARTTV' ) { //eslint-disable-line
        deviceInfo.type = 'smart-tv1314';
        callback(deviceInfo);
    } else {
        callback(deviceInfo);
    }
};
